<div class="dialog-container">
  <!-- Search Section -->
  <div class="search-section" *ngIf="data.section !== 'party-Id' && data.section !== 'party-name'">
    <div class="header">
      <div class="text-xl" style="font-weight: bold;">Select Parties</div>
      <button mat-icon-button (click)="closeDialog()" class="close-icon">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="search-bar">
      <mat-label>Search Parties</mat-label>
      <mat-form-field class="search-form-field" appearance="outline">
        <input
          matInput
          [(ngModel)]="searchQuery"
          (input)="onSearchInputChange($event)" 
          placeholder="Search by party name"
            />  
        <button mat-icon-button matSuffix (click)="clearFilter()" *ngIf="searchQuery">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>

  <!-- Scrollable Table Section -->
  <div class="table-section" (scroll)="onScroll($event)">
    <div class="table-scroll-container">
      <table mat-table [dataSource]="partiesData()" class="mat-elevation-z8 custom-table">
        <!-- Party Type Column -->
        <ng-container matColumnDef="prtType">
          <th mat-header-cell *matHeaderCellDef class="sticky-header">Party Type</th>
          <td mat-cell *matCellDef="let row">{{ row.prtType }}</td>
        </ng-container>

        <!-- Party ID Column -->
        <ng-container matColumnDef="partiesId">
          <th mat-header-cell *matHeaderCellDef class="sticky-header">Party ID</th>
          <td mat-cell *matCellDef="let row">{{ row.partiesId }}</td>
        </ng-container>

        <!-- Full Name Column -->
        <ng-container matColumnDef="partiesFullName">
          <th mat-header-cell *matHeaderCellDef class="sticky-header">Full Name</th>
          <td mat-cell *matCellDef="let row">{{ row.partiesFullName }}</td>
        </ng-container>

        <!-- Select Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="sticky-header">Select</th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              *ngIf="data.multi"
              [checked]="multiSelectedRows.includes(row)"
              (change)="onMultiSelectToggle(row, $event.checked)">
            </mat-checkbox>
        
            <mat-checkbox
              *ngIf="!data.multi"
              [checked]="selectedRow === row"
              (change)="onRowSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <!-- Loader Row -->
      <div *ngIf="loading" class="table-loader">
        <mat-spinner diameter="30"></mat-spinner>
      </div>
    </div>
  </div>

  <!-- Buttons Section -->
  <div class="button-section">
    <button mat-button color="warn" class="cancel-button" (click)="closeDialog()">Cancel</button>
    <button mat-button color="primary" class="submit-button" (click)="addPartyconfirmation()">
      {{ data.section !== 'party-Id' && data.section !== 'party-name' ? 'Add Party' : 'Select Party' }}
    </button>
  </div>
</div>
